import React, { useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './components/Layout';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Routing from './components/Routes';
import LoginForm from './components/Onboarding/LoginForm';
import Onboarding from './pages/Onboarding';
import DoshaQuiz from './pages/DoshaQuiz';
import MiniDoshaQuiz from './pages/DoshaQuiz/MiniDoshaQuiz';
import MiniDoshaResult from './pages/DoshaQuiz/MiniDoshaResult';
import { AuthProvider } from './components/Context/authContext';
import { RouterContextProvider } from './components/Common/useRouterContext';
import { CompanyProvider } from './context/CompanyContext';
import DoshaResult from './pages/DoshaQuiz/DoshaResult';
import { MINI_QUIZ_UID } from './pages/DoshaQuiz/miniQuizConfig';
import { trackPageView } from './utils/gtm';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  // Initialize GTM dataLayer and track initial page view
  useEffect(() => {
    // Initialize dataLayer if it doesn't exist (works on all environments)
    window.dataLayer = window.dataLayer || [];
    
    // Add a small delay to ensure GTM script is loaded
    const initializeGTM = () => {
      // Track initial page view
      trackPageView('App', window.location.pathname);
      
      // Track route changes
      const handleRouteChange = () => {
        trackPageView('App', window.location.pathname);
      };
      
      // Listen for route changes
      window.addEventListener('popstate', handleRouteChange);
      
      return () => {
        window.removeEventListener('popstate', handleRouteChange);
      };
    };
    
    // Initialize immediately and also after a short delay to ensure GTM is loaded
    initializeGTM();
    const timeoutId = setTimeout(initializeGTM, 100);
    
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <RouterContextProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginForm />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/dosha-quiz-intro" element={<DoshaQuiz />} />
              <Route path={`/dosha-quiz/${MINI_QUIZ_UID}`} element={<MiniDoshaQuiz />} />
              <Route path="/dosha-quiz/mini-result" element={<MiniDoshaResult />} />
              <Route path="/dosha-quiz/:uid?" element={<DoshaQuiz />}/>
          <Route path="/dosha-quiz/dosha-result" element={<DoshaResult />   } />
              <Route
                path="/*"
                element={
                  <Layout>
                    <CompanyProvider>
                      <Routing />
                    </CompanyProvider>
                  </Layout>
                }
              />
            </Routes>
          </AuthProvider>
        </RouterContextProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
